import React from 'react';
import SmartLink from 'components/smartLink';
import { ReactComponent as Logo } from 'images/logo.svg';
import { ReactComponent as TwitterIcon } from 'images/icon-twitter.svg';
import { ReactComponent as FacebookIcon } from 'images/icon-facebook.svg';
import { ReactComponent as InstagramIcon } from 'images/icon-instagram.svg';
import { ReactComponent as YoutubeIcon } from 'images/icon-youtube.svg';
import { ReactComponent as LinkedinIcon } from 'images/icon-linkedin-alt.svg';

import styles from './footer.module.scss';

export default function Footer() {
  return (
    <footer className={styles.container}>
      <div className={styles.inner}>
        <Logo className={styles.logo} role='img' aria-label='Newsela Logo' />
        <div className={styles.footer_footer}>
          <div>&copy; {new Date().getFullYear()} Newsela Inc.</div>
          <div className={styles.legal}>
            <SmartLink
              to='https://newsela.com/about/terms'
              className={styles.footer_link}
            >
              Terms
            </SmartLink>
            <SmartLink
              to='https://newsela.com/about/privacy-policy'
              className={styles.footer_link}
            >
              Privacy
            </SmartLink>
            <SmartLink
              to='https://support.newsela.com/article/newsela-accessibility-statement/'
              className={styles.footer_link}
            >
              Accessibility
            </SmartLink>
          </div>
          <div className={styles.social}>
            <SmartLink
              to='https://twitter.com/Newsela'
              target='_blank'
              className={styles.footer_link}
              alt='Twitter'
              aria-label='Twitter'
            >
              <TwitterIcon />
            </SmartLink>
            <SmartLink
              to='https://www.facebook.com/Newsela/'
              target='_blank'
              className={styles.footer_link}
              alt='Facebook'
              aria-label='Facebook'
            >
              <FacebookIcon />
            </SmartLink>
            <SmartLink
              to='https://www.instagram.com/newsela'
              target='_blank'
              className={styles.footer_link}
              alt='Instagram'
              aria-label='Instagram'
            >
              <InstagramIcon />
            </SmartLink>
            <SmartLink
              to='https://www.youtube.com/user/Newsela/videos'
              target='_blank'
              className={styles.footer_link}
              aria-label='YouTube'
            >
              <YoutubeIcon />
            </SmartLink>
            <SmartLink
              to='https://www.linkedin.com/company/newsela'
              target='_blank'
              className={styles.footer_link}
              alt='LinkedIn'
              aria-label='Linkedin'
            >
              <LinkedinIcon />
            </SmartLink>
          </div>
        </div>
      </div>
    </footer>
  );
}
